import { render, staticRenderFns } from "./TablePurchase.vue?vue&type=template&id=8cbe0d1a"
import script from "./TablePurchase.vue?vue&type=script&lang=js"
export * from "./TablePurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports